module.exports = __webpack_public_path__ + "static/img/EG_H5.f88f970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/EG_H5.png
// module id = fbnZ
// module chunks = 34